<div class="checklist-paragraph">

  @if (loading) {
    <hpo-placeholder
    type="row"></hpo-placeholder>
  }

  @if (!loading) {
    @if (data.self.attributes.field_title) {
      <h2
        class="checklist-paragraph__title">
        {{data.self.attributes.field_title}}
      </h2>
    }
    <div class="checklist-paragraph__content"
    [innerHTML]="sanitizedHtml"></div>
  }

</div>